import React, { useReducer } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import statesList from '../states.json';
import isEmail from 'validator/lib/isEmail';
import { WithApiAccess } from '../lib/HigherOrderComponents/WithApiAccess';
import '../components/clearpoint.css';
import '../components/clearpoint.css';

const Signup = (props) => {

    const initialState = {
        signupAccepted: false,
        emailAddress: { value: '', required: true, touched: false, invalid: true, message: '' },
        confirmEmailAddress: { value: '', required: true, touched: false, invalid: true, message: '' },
        firstName: { value: '', required: true, touched: false, invalid: true, message: '' },
        lastName: { value: '', required: true, touched: false, invalid: true, message: '' },
        phoneNumber: { value: '', required: true, touched: false, invalid: true, message: '' },
        businessName: { value: '', required: true, touched: false, invalid: true, message: '' },
        city: { value: '', required: true, touched: false, invalid: true, message: '' },
        stateOrProvince: { value: '', required: true, touched: false, invalid: true, message: '' }
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'idBlurred':
                return {
                    ...state,
                    [action.payload]: {
                        ...state[action.payload],
                        touched: true
                    }
                }
            case 'idChanged':
                const {id, value} = action.payload;
                return {
                    ...state,
                    [id]: {
                        ...state[action.payload],
                        value: value
                    }
                }
            case 'invalidateField':
                return {
                    ...state,
                    [action.payload.id]: {
                        ...state[action.payload.id],
                        invalid: action.payload.invalid, 
                        message: action.payload.message
                    }
                }
            case 'setValidity':
                return {
                    ...state,
                    [action.payload.fieldName]: {
                        ...state[action.payload.fieldName],
                        invalid: action.payload.invalid, 
                        message: action.payload.message
                    }
                }
            case 'signupAccepted':
                return {
                    ...state,
                    signupAccepted: action.payload,
                }
            default:
                throw new Error();
        }
    }

    const [formData, dispatch] = useReducer(reducer, initialState);

    //form validation technique changed
    const formIsValid = () =>
    {
        const { emailAddress, confirmEmailAddress } = formData;
        const emailsMatch = emailAddress.value === confirmEmailAddress.value;
        var invalidFields = Object.keys(formData).filter(field=>formData[field].hasOwnProperty('invalid') 
            && formData[field].value === '');

        return invalidFields.length === 0 && emailsMatch;
    };

    //changing how the errors are checked could potentially cause problems
    //For example, its only checking to see if confirm email field contains a text
    const shouldMarkError = (id) => {
        const field = formData[id];
        const result = field.value === '' && field.touched;
        return result;
    };

    const handleBlur = (event) => 
    {
        const { id } = event.target;
        dispatch({ type: 'idBlurred', payload: id })
    }

    const handleChange = (callback) => (event) =>
    {
        const { id, value }  = event.target;
        dispatch({ type: 'idChanged', payload: {id, value} })
       
        const field = formData[id];
        if (field.required) requireField(id);
        if (typeof(callback) === "function")
        {
            callback();
        }
    }

    const requireField = (id) => 
    {
        let invalid;
        let message;
        var field = formData[id];
        if (field.required && field.touched && field.value === ''){
            invalid = true;
            message = 'Required. ';
        }
    }

    const setFieldValidity = (fieldName, invalid, message) => {
        dispatch({ type: 'setValidity', payload: {fieldName, invalid, message} })
    };

    const checkEmailValidity = () => {
        var invalid = false;
        var message = '';

        const { emailAddress } = formData;
        if (emailAddress.value.length === 0 )
        {
            invalid = true;
            message = 'Required. ';
        }

        if (!isEmail(emailAddress.value))
        {
            invalid = true;
            message = 'Not a valid email address';
        }

        setFieldValidity('emailAddress', invalid, message);
    }

    const checkConfirmEmailValidity = () => {
        var invalid = false;
        var message = '';

        const { emailAddress, confirmEmailAddress } = formData;
        if (confirmEmailAddress.value.length === 0 )
        {
            invalid = true;
            message = 'Required. ';
        }

        if (!isEmail(confirmEmailAddress.value))
        {
            invalid = true;
            message = 'Not a valid email address';
        }

        if (confirmEmailAddress.value !== emailAddress.value)
        {
            invalid = true;
            message = 'Email addresses must match';
        }

        setFieldValidity('confirmEmailAddress', invalid, message);
    }

    const getDataForApiFromState = () =>
    {
        const { 
            emailAddress, 
            confirmEmailAddress, 
            firstName, 
            lastName, 
            phoneNumber,
            businessName,
            stateOrProvince,
            city } = formData;

        return {
            emailAddress: emailAddress.value,
            confirmEmailAddress: confirmEmailAddress.value,
            firstName: firstName.value,
            lastName: lastName.value,
            phoneNumber: phoneNumber.value,
            businessName: businessName.value,
            city: city.value,
            state: stateOrProvince.value
        };
    };

    const submit = async (event) =>
    {
        event.preventDefault();
        await props.api.post('api/account/signup', getDataForApiFromState())
        .then(response => {
            if (response.status === 200) { 
                return response.data;
            }
        })
        .then(data => {
            dispatch({ type: 'signupAccepted', payload: true });
        });
    }

    const { 
        signupAccepted,
        emailAddress,
        confirmEmailAddress,
        firstName, 
        lastName, 
        phoneNumber,
        businessName,
        stateOrProvince,
        city 
    } = formData;

    const excludedStates = ['AS','PR','VI'];
    var states = [...Object.keys(statesList)].filter(s=>excludedStates.indexOf(s) < 0);

    if (signupAccepted) {
        return (
            <div className="card card-body card-default sm-panel">
                <h3 className="section mt-0">Signup Received</h3>
                <Row>
                    <Col sm={12} className="pr-50">
                        <p>
                            Your request to Sign Up for the ClearPoint Client Portal has been received.  We will
                            contact you regarding your account setup.
                        </p>
                        <p>
                            If you have any questions, you can contact our Customer Service Team at (800)763-0234.
                        </p>
                        <br/>
                        <div className="form-group text-left mb-0">
                            <Link to={"/"} className="btn btn-primary">Return Home</Link>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    } else {
        return (
            <div className="lg-panel">
            <Form onSubmit={submit} >
                <div className="header section">
                    SIGN UP
                </div>
                <Row>
                    <Col sm={6} className="pr-50">
                        <div className="section muted-bold h40">
                            Please enter your email address. We will contact you to complete your account setup.
                        </div>
                        <Row className="form-group">
                            <label htmlFor="emailAddress" className="col-sm-4 col-form-label">Email Address:</label>
                            <Col sm={8}>
                                <input type="text" className={"form-control form-input" + (shouldMarkError("emailAddress") ? " error" : null)}                                
                                    id="emailAddress" 
                                    name="emailAddress" 
                                    placeholder="yours@example.com" 
                                    value={emailAddress.value} 
                                    onBlur={handleBlur}
                                    onChange={handleChange(checkEmailValidity)}/>
                            </Col>
                        </Row>
                        <Row className="form-group">
                            <label htmlFor="confirmEmailAddress" className="col-sm-4 col-form-label">Confirm Email:</label>
                            <Col sm={8}>
                                <input type="text" className={"form-control form-input" + (shouldMarkError("confirmEmailAddress") ? " error" : null)}
                                    id="confirmEmailAddress" 
                                    name="confirmEmailAddress" 
                                    placeholder="yours@example.com" 
                                    value={confirmEmailAddress.value} 
                                    onBlur={handleBlur}
                                    onChange={handleChange(checkConfirmEmailValidity)}/>
                            </Col>
                        </Row>
                        <Row className="form-group">
                            <label htmlFor="firstName" className="col-sm-4 col-form-label">First Name:</label>
                            <Col sm={8}>
                                <input type="text" className={"form-control form-input" + (shouldMarkError("firstName") ? " error" : "")}
                                    id="firstName" 
                                    name="firstName" 
                                    placeholder="First Name"
                                    value={firstName.value} 
                                    onBlur={handleBlur}
                                    onChange={handleChange()}/>
                            </Col>
                        </Row>
                        <Row className="form-group">
                            <label htmlFor="lastName" className="col-sm-4 col-form-label">Last Name:</label>
                            <Col sm={8}>
                                <input type="text" className={"form-control form-input" + (shouldMarkError("lastName") ? " error" : null)}
                                    id="lastName" 
                                    name="lastName" 
                                    placeholder="Last Name" 
                                    value={lastName.value} 
                                    onBlur={handleBlur}
                                    onChange={handleChange()}/>
                            </Col>
                        </Row>
                        <Row className="form-group">
                            <label htmlFor="phoneNumber" className="col-sm-4 col-form-label">Phone Number:</label>
                            <Col sm={8}>
                                <input type="text" className={"form-control form-input" + (shouldMarkError("phoneNumber") ? " error" : null)}
                                    id="phoneNumber" 
                                        name="phoneNumber" 
                                        placeholder="Phone Number" 
                                        value={phoneNumber.value} 
                                        onBlur={handleBlur}
                                        onChange={handleChange()}/>
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={6} className="pl-50 border-start border-3">
                        <p className="section muted-bold h40">Please tell us about your Funeral Home or Cemetery Business.</p>
                        <Row className="form-group">
                            <label htmlFor="businessName" className="col-sm-4 col-form-label">Business Name:</label>
                            <Col sm={8}>
                                <input type="text" className={"form-control form-input" + (shouldMarkError("businessName") ? " error" : null)}
                                    id="businessName" 
                                    name="businessName" 
                                    placeholder="Business Name" 
                                    value={businessName.value} 
                                    onBlur={handleBlur}
                                    onChange={handleChange()}/>
                            </Col>
                        </Row>
                        <Row className="form-group">
                            <label htmlFor="city" className="col-sm-4 col-form-label">City:</label>
                            <Col sm={8}>
                                <input type="text" className={"form-control form-input" + (shouldMarkError("city") ? " error" : null)} 
                                    id="city" 
                                    name="city" 
                                    placeholder="City" 
                                    value={city.value} 
                                    onBlur={handleBlur}
                                    onChange={handleChange()}/>
                            </Col>
                        </Row>
                        <Row className="form-group">
                            <label htmlFor="stateOrProvince" className="col-sm-4 col-form-label">State:</label>
                            <Col sm={3}>
                                <select className={"form-control form-input" + (shouldMarkError("stateOrProvince") ? " error" : null)} 
                                    id="stateOrProvince"
                                    value={stateOrProvince.value}
                                    onBlur={handleBlur}
                                    onChange={handleChange()}>
                                    {(!stateOrProvince.value) &&
                                    <option value=''>{" "}</option>
                                    }
                                    {states.map((state, i) => 
                                        <option key={i} value={state}>{state}</option>
                                    )}
                                </select>
                            </Col>
                        </Row>
                        <div className="form-group text-left section">
                            <button type="submit" disabled={!formIsValid()} className="btn btn-primary">Sign Up</button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </div>
        );
    }
}

export default WithApiAccess(Signup);